var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceZeroDarkweb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.667 25.08L63.1672 10.6667L109.326 25.08V27.7603C69.6841 29.8056 31.5749 42.0111 18.6892 47.9772L18.667 47.992V25.0873V25.08ZM18.6818 58.1152C18.8521 66.9093 20.9849 75.4081 24.7692 83.0725C37.1588 70.6677 71.1504 43.0005 71.1504 43.0005L18.6818 58.1152ZM34.6631 97.3233C38.1881 101.082 42.2316 104.404 46.7268 107.181L63.1672 117.333L80.4444 107.048C91.0715 100.727 99.2546 91.3719 104.15 80.4734C86.1245 83.006 52.4735 92.2432 34.6557 97.3306L34.6631 97.3233ZM109.26 59.2301C109.304 58.2628 109.334 57.2956 109.334 56.3283V35.9342C94.367 43.4804 64.4484 58.8462 55.7616 68.8882C65.9443 66.7764 98.5363 61.0909 109.26 59.2227V59.2301Z",
    fill: "#FF7F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceZeroDarkweb);
export default __webpack_public_path__ + "static/media/service-zero-darkweb.053bd8be39c1b0d64385fc1188994cf3.svg";
export { ForwardRef as ReactComponent };